/* ==========================================================================
   Koolseed — Video kartı

   Kart kapakla duruyor; videoya ancak tıklanınca dokunuluyor. Bir bölümde
   dört altı kart olduğu için hepsini baştan yüklemek açılışı yavaşlatırdı.

   Oynatıcı sunucudan <template> içinde geliyor: tarayıcı şablonun içindeki
   kaynağı indirmiyor, biz DOM'a taşıyana kadar dosyaya el sürülmüyor.

   Bir kartta video başlayınca diğerleri duruyor — aynı anda iki ses
   çalmasın.
   ========================================================================== */

(function () {
  'use strict';

  class KsVideo extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-video-play]');
      this.template = this.querySelector('[data-video-player]');
      if (!this.trigger || !this.template) return;

      this.trigger.addEventListener('click', () => this.play());
    }

    play() {
      if (this.player) {
        this.player.play();
        return;
      }

      const node = this.template.content.cloneNode(true);
      this.player = node.querySelector('video');
      if (!this.player) return;

      this.template.remove();
      this.trigger.remove();
      this.appendChild(node);
      this.classList.add('is-playing');

      // Diğer kartlar sussun.
      this.player.addEventListener('play', () => {
        document.querySelectorAll('ks-video.is-playing video').forEach((other) => {
          if (other !== this.player) other.pause();
        });
      });

      const started = this.player.play();
      if (started && typeof started.catch === 'function') started.catch(function () {});
    }
  }

  if (!customElements.get('ks-video')) customElements.define('ks-video', KsVideo);
})();
